var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutlineIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 14,
  height: 14,
  rx: 2,
  stroke: "white",
  strokeWidth: 2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutlineIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "c0da616b12a7c03aebb181b15c6b0313.svg";